import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PendingOBSApi } from '../../components/PendingOBSApi';
import { ensureOBSMinVersion } from '../../utils/ensureOBSPresence';
import { UnsupportedOBSVersion } from '../../components/UnsupportedOBSVersion';
import { UnsupportedOBSVersionError } from '../../types/errors';

const onboardingMinVersion = [24, 12, 23, 323];

export const Route = createFileRoute('/_authenticated/onboarding/_ensure-version')({
  component: () => <Outlet />,
  pendingComponent: PendingOBSApi,
  errorComponent: EnsureVersion,
  loader: async () => {
    document.title = 'StreamElements - Multi-Streaming Onboarding';

    const { seLiveMultiStreamingMinVersionOk } = await ensureOBSMinVersion({
      minVersion: onboardingMinVersion,
    });

    if (!seLiveMultiStreamingMinVersionOk) {
      throw new UnsupportedOBSVersionError(
        'Outdated OBS version. Please install the latest version of SE.Live (beta).'
      );
    }

    return { seLiveMultiStreamingMinVersionOk };
  },
});

function EnsureVersion() {
  return <UnsupportedOBSVersion minVersion={onboardingMinVersion} />;
}
